<template>
    <div>
      <van-nav-bar 
      left-text="返回"
            left-arrow
            fixed
            @click-left="goHome"
        style="position:fixed;width:100%">
          <template #title>
            <span>报工详情</span>
          </template>
        </van-nav-bar>
  
      <van-row style="padding-top:60px">
          <van-form ref="checkbox">
            <van-cell-group inset>
                <van-field name="radio" label="报工时间">
                <template #input>
                  <van-radio-group v-model="type" direction="horizontal" style="font-size:10px">
                    <van-radio name="今天">今天</van-radio>
                    <van-radio name="昨天">昨天</van-radio>
                    <van-radio name="本周">本周</van-radio>
                    <van-radio name="本月">本月</van-radio>
                    <van-radio name="全部">全部</van-radio>
                    <van-radio name="自定义" >自定义</van-radio>
                  </van-radio-group>
                </template>
              </van-field>

                <van-field
                  v-model="startDateTimeFormatter"
                  center
                  clearable
                  label="起始日期"
                  placeholder=""
                  @click="$refs.startDateSelectDialog.open(queryParams.startDate)"
                >
                  <template #button>
                    <van-icon name="clear" size="18" @click.stop="queryParams.startDate = ''" style="font-size:16px"/>
                  </template>
                </van-field>
      
                <van-field
                  v-model="endDateTimeFormatter"
                  center
                  clearable
                  label="结束日期"
                  placeholder=""
                  @click="$refs.endDateSelectDialog.open(queryParams.endDate)"
                >
                  <template #button>
                    <van-icon name="clear" size="18" @click.stop="queryParams.endDate = ''" style="font-size:16px"/>
                  </template>
                </van-field>
            </van-cell-group>
          </van-form>
        </van-row>

        <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 4px',margin:'4px 20px 0px','font-size':'14px','line-height':'18px'}">查询结果共<span style="color:red;margin:4px">{{list.length}}</span>笔</van-divider>
  
        <van-row style="padding-top:10px">
            <van-list  
              style="overflow: scroll;padding:0 20px;overflow-y: auto;"
              :style="{ height:innerHeight}"
            >
                <van-cell v-for="(item,index) in list" :key="index" title="" style="margin:10px 0" >
                  <!-- 使用 right-icon 插槽来自定义右侧图标 -->
                  <template #label>
                    <div>
                      <van-row >
                        <div class="reportContent">
                          <van-col span="24" class="title" style="width:100%;text-align:left;font-size:18px;color:rgb(25, 137, 250)">{{ item.id }}【{{item.date}}】</van-col>

                          <van-col span="24" style="margin-top:4px">
                            <span class="title">部门编号:</span>{{item.department}}
                          </van-col>
                          <van-col span="24" style="margin-top:4px">
                            <span class="title">部门:</span>{{item.departmentName }}
                          </van-col>  
                          <van-col span="24" style="margin-top:4px">
                            <span class="title">工单号:</span>{{item.woId}}
                          </van-col>
                          <van-col span="24" style="margin-top:4px">
                            <span class="title">工单序号:</span>{{item.woIndex}}
                          </van-col>
                          <van-col span="24" style="margin-top:4px">
                            <span class="title">工艺编号:</span>{{item.workmanship}}
                          </van-col>
                          <van-col span="24" style="margin-top:4px">
                            <span class="title">工艺名称:</span>{{item.workmanshipName}}
                          </van-col>
                          <van-col span="24" style="margin-top:4px">
                            <span class="title">品号:</span>{{item.productId}}
                          </van-col>
                          <van-col span="24" style="margin-top:4px">
                            <span class="title">品名:</span>{{item.productName}}
                          </van-col>
                          <van-col span="24" style="margin-top:4px">
                            <span class="title">规格:</span>{{item.spec}}
                          </van-col>
                          <van-col span="24" style="margin-top:4px" v-if="finishType == '1'||finishType == '0'">
                            <span class="title">报工数:</span>{{item.passCount}}
                          </van-col>
                          <van-col span="24" style="margin-top:4px" v-if="finishType == '2'||finishType == '0'">
                            <span class="title">报废数:</span>{{item.unpassCount}}
                          </van-col>
                          <van-col span="24" style="margin-top:4px">
                            <span class="title">加工单价:</span>{{item.unitPrice}}元
                          </van-col>
                          <van-col span="24" style="margin-top:4px">
                            <span class="title">加工金额:</span>{{item.totalPrice}}元
                          </van-col>
                          <van-col span="24" style="margin-top:4px">
                            <span class="title">扣减金额:</span>{{item.subPrice}}元
                          </van-col>
                        </div>
                      </van-row>
                    </div>
                  </template>
              </van-cell>
             
          </van-list>
        </van-row>
  
        <van-row style="padding:15px 2px 10px">
            <van-button round   size="large" type="info" @click="getDetail" style="height:30px;">查询</van-button>
        </van-row>

        <DateSelectDialog
            ref="startDateSelectDialog"
            @confirm="(date) => (queryParams.startDate = date)"
            
            ></DateSelectDialog>

            <DateSelectDialog
            ref="endDateSelectDialog"
            @confirm="(date) => (queryParams.endDate = date)"
            ></DateSelectDialog>
    </div>
  </template>
    
    <script>
  import Vue from 'vue'
  import { router }  from '../../router'
  import { getHomePageDetail } from '../../api/wms/statistic/index'
  import { Toast,Dialog} from 'vant';
  
  export default {
      components: {
  
      },
      computed: {
        startDateTimeFormatter() {
            return !this.queryParams.startDate || this.queryParams.startDate == ""
                ? ""
                : this.$dateTimeUtil.formate("YYYY年mm月dd日", this.queryParams.startDate);
            },
        endDateTimeFormatter() {
            return !this.queryParams.endDate || this.queryParams.endDate == ""
                ? ""
                : this.$dateTimeUtil.formate("YYYY年mm月dd日", this.queryParams.endDate);
            }
        },
      data() {
        return {
          innerHeight:window.innerHeight - 320 + 'px',
          list:[],
          isDatePickerEnabled:false,
          type:'今天',
          finishType:'0',
          queryParams: {
            startDate: "",
            endDate:"",
        },
          showPopover: false
        };
      },
      mounted(){
        
        var params =  window.location.href.split('type=');// this.$router.query;
        var params1 = window.location.href.split('finishType=');
        this.queryParams.startDate = new Date(); 
        this.queryParams.endDate = new Date(); 
        
        this.type = decodeURIComponent(params[1].split('&')[0]);
        this.finishType = decodeURIComponent(params1[1]);

        this.getDetail();
        this.$forceUpdate();
      },
      methods: {
        updateStore(data){
          if(data.id == this.store.id){
            return;
          }

          //初始化数据
          this.store = data;
        },
        getDetail(){
          var startDate = this.queryParams.startDate == ""?"":this.$dateTimeUtil.formate("YYYY-mm-dd", this.queryParams.startDate);
          var endDate = this.queryParams.endDate == ""?"":this.$dateTimeUtil.formate("YYYY-mm-dd", this.queryParams.endDate);

          Toast.loading({
            message: '加载中...',
            forbidClick: true,
            duration: 0 
          });

            getHomePageDetail(this.type,startDate,endDate,this.finishType).then(res=>{
                Toast.clear();

                if(res.code == 200){
                this.list = res.data;
                }
                else{
                Toast(res.message);
                }
            });
        },
        goHome(){
          this.$router.push({
            path:'/home',
            query:{
              active:0
            }
          });
        }
      }
    }; 
    </script>
    
    <style scoped>
    .select{
      border:1px solid rgb(255, 56, 30)
    }
    
    .reportContent{
      font-size:14px;
      color:#323233
    }
  
    .reportContent .title{
      display: inline-block;
      width:64px;
      text-align: right;
      font-weight: 700;
    }
    </style>

<style lang="less" scoped>
.van-field__label{
  width:3.2em !important;
}

.van-radio--horizontal{
  margin-bottom:4px !important;
}
</style>
